import { cn } from "@/lib/cn";
import type { BadgeTono } from "./Badge";

// Mismos tonos que Badge, pero como color sólido (acá no hay texto encima que necesite el "-suave").
const RELLENO: Record<BadgeTono, string> = {
  neutro: "bg-texto-suave",
  primario: "bg-primario",
  exito: "bg-exito",
  alerta: "bg-alerta",
  peligro: "bg-peligro",
};

export interface BarraProgresoProps {
  /** Puede superar 100 (excedido): el ancho y el `aria-valuenow` se acotan a 0–100. `null` = todavía sin dato. */
  porcentaje: number | null;
  tono: BadgeTono;
  etiqueta: string;
  /** `normal` (por defecto) = `h-2`; `grande` = `h-4`, para cuando la barra es el elemento principal de la pantalla. */
  alto?: "normal" | "grande";
  className?: string;
}

const ALTO: Record<"normal" | "grande", string> = { normal: "h-2", grande: "h-4" };

/** Barra de progreso accesible para "consumido del presupuesto". `porcentaje === null` se ve vacía, sin valor. */
export function BarraProgreso({ porcentaje, tono, etiqueta, alto = "normal", className }: BarraProgresoProps) {
  const acotado = porcentaje === null ? null : Math.min(100, Math.max(0, porcentaje));
  return (
    <div
      role="progressbar"
      aria-label={etiqueta}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={acotado ?? undefined}
      className={cn("w-full overflow-hidden rounded-full bg-superficie-2", ALTO[alto], className)}
    >
      {acotado !== null && <div className={cn("h-full rounded-full", RELLENO[tono])} style={{ width: `${acotado}%` }} />}
    </div>
  );
}
